import React, { useRef, useState } from "react";
import * as S from "./GuidanceCaseOptions.style"
import { useTranslation } from "react-i18next";
import FlorenzButton from "../../../../../../../florenzComponents/florenzButton";

const specificGuidesMonaco = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/specific-guides-monaco.svg`;

function GuidanceCaseOptions({
  selectedProcess,
  selectedPartition,
  selectedPatient,
  setActiveModalGuideSelector,
  setActiveModalPatient,
  setStartChat
}) {

  const {t, i18n: { language }} = useTranslation("global");   

  return (
    <S.GuidanceCaseOptions>
      <div className="selector">
        <div className="selector-label">
          <div className="selector-label__imgs">
            <img className="selector-label__img" src={specificGuidesMonaco} alt="specificGuidesMonaco" />
            {
              selectedPatient && <img className="selector-label__img-patient" src={selectedPatient?.picture} alt="specificGuidesMonaco" />
            }
          </div>
          <div className="selector-label__title">
            {t("chatbotAI.guidelines.guideSelection")}
          </div>
        </div>
        <div className="options">
          <S.Option
            onClick={() => {
              setActiveModalGuideSelector(true);
            }}
          >
            <div className="left">
              <div className="number">1</div>
              <div className="title">{
                selectedPartition 
                ? <>
                  <b>{t("globally.guide")}</b> {`${selectedPartition.text}`}
                </> 
                : t("chatbotAI.guidelines.selectGuide")
              }</div>
            </div>
            <div className="right">
              <i className="right-icon zaia-icono-dots-horizontal"></i>
            </div>
          </S.Option>
          <S.Option
            disabled={!selectedPartition}
            onClick={() => {              
              setActiveModalPatient(true);
            }}
          >
            <div className="left">
              <div className="number">2</div>
              <div className="title">{
                selectedPatient 
                ? <>
                  <b>{t("globally.patient")}</b> {`${selectedPatient.name} ${selectedPatient.lastname}`}
                </> 
                : `${t("globally.selectPatient")} (${t("globally.optional")})`
              }</div>
            </div>
            <div className="right">
              {
                !selectedPartition
                ? <i className="right-icon zaia-i-lock-chat"></i>
                : <i className="right-icon zaia-icono-dots-horizontal"></i>
              }
            </div>
          </S.Option>
        </div>
      </div>
      <div className="button-container">
        <FlorenzButton
          typeStyle={"success"}
          size="m"
          text={t("globally.continue")}
          widthComplete={true}
          icon={!selectedPartition && "zaia-i-lock-chat"}     
          disabled={!selectedPartition}         
          onClick={() => {
            setStartChat(true);
          }}
        />
      </div>
    </S.GuidanceCaseOptions>
  );
  

}

export default GuidanceCaseOptions;
